import { animate, group, keyframes, query, stagger, style, transition, trigger } from '@angular/animations';

export const backButtonAnimation = trigger('backButton', [
  transition(
    ':enter',
    animate(
      '200ms cubic-bezier(.3, .62, 0, 1.01)', // http://cubic-bezier.com/#.3,.62,0,1.01
      keyframes([
        style({ opacity: '.4', transform: 'translateX(3rem)' }),
        style({ opacity: '1', transform: 'translateX(0)' }),
      ])
    )
  ),
]);

export const listAnimation = trigger('list', [
  transition('void => false', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(2rem)' }),
        stagger(
          '.08s',
          group([
            animate('100ms ease-out', style({ opacity: 1 })),
            animate('200ms ease-out', style({ transform: 'translateY(0)' })),
          ])
        ),
      ],
      { optional: true }
    ),
  ]),
]);
